import { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { MdOutlineSettings } from 'react-icons/md';

const dropdownMenuStyle: React.CSSProperties = {
  backgroundColor: "#1a1a1a",
  borderRadius: "12px",
  border: "none",
  padding: "6px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
  minWidth: "52px",
};

const dropdownItemStyle: React.CSSProperties = {
  color: "white",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "40px",
  height: "40px",
  padding: "0",
  margin: "2px 0",
  cursor: "pointer",
};

export default function FloatingToolbar({ items = [] }: any) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [menuStyle, setMenuStyle] = useState<React.CSSProperties>({});
  const [dropUp, setDropUp] = useState(false);
  const toggleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!showDropdown || !toggleRef.current) return;

    const rect = toggleRef.current.getBoundingClientRect();
    const itemHeight = 44;
    const menuPadding = 12;
    const totalMenuHeight = (items.length + 1) * itemHeight + menuPadding;
    const spaceBelow = window.innerHeight - rect.bottom;
    const shouldDropUp = spaceBelow < totalMenuHeight;

    setDropUp(shouldDropUp);
    setMenuStyle(
      shouldDropUp
        ? { bottom: window.innerHeight - rect.top - 36, left: rect.left - 11 }
        : { top: rect.bottom - 36, left: rect.left - 11 }
    );
  }, [showDropdown, items.length]);

  const menu = showDropdown
    ? ReactDOM.createPortal(
        <>
          <style>{`
            .dropdown-item-dark:hover,
            .dropdown-item-dark:focus {
              background-color: rgba(255, 255, 255, 0.1);
              color: white;
            }
            .dropdown-item-dark:active {
              background-color: rgba(255, 255, 255, 0.2);
            }
            .dropdown-item-labeled:hover .crea-label {
              display: block !important;
            }
          `}</style>
          <div
            style={{ ...dropdownMenuStyle, position: "fixed", zIndex: 999999, ...menuStyle }}
            onMouseLeave={() => setShowDropdown(false)}
            onMouseOver={() => setShowDropdown(true)}
          >
            {!dropUp && (
              <div style={{ ...dropdownItemStyle, color: "gray" }} className="dropdown-item-dark">
                <MdOutlineSettings className="text-bold" size={24} />
              </div>
            )}
            {items.map((item, idx) => (
              <div
                key={idx}
                style={{ ...dropdownItemStyle, position: "relative" }}
                className="dropdown-item-dark dropdown-item-labeled"
              >
                {item}
              </div>
            ))}
            {dropUp && (
              <div style={{ ...dropdownItemStyle, color: "gray" }} className="dropdown-item-dark">
                <MdOutlineSettings className="text-bold" size={24} />
              </div>
            )}
          </div>
        </>,
        document.body
      )
    : null;

  return (
    <>
      <div
        ref={toggleRef}
        style={{ cursor: "pointer", display: "inline-flex", fontWeight: "bolder", marginTop: 4, paddingLeft: 2, width: 72 }}
        onMouseLeave={() => setShowDropdown(false)}
        onMouseOver={() => setShowDropdown(true)}
      >
        <MdOutlineSettings size={24} />
      </div>
      {menu}
    </>
  );
}
